<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeBuy.AmountFrom" :decimal="0" label="Tổng tiền (Min)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeBuy.AmountTo" :decimal="0" label="Tổng tiền (Max)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeBuy.FeePercent" :decimal="2" label="Phí mua hàng" class="input-group--focused"></h-currency-input>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.feeBuy.loading,
            feeBuy: state => state.feeBuy.selected,
            stores: state => state.commons.stores,
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("feeBuy/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("feeBuy/setDetail", { data: {
                        ID: 0,
                        AmountFrom: 0,
                        AmountTo: 0,
                        FeePercent: 0
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("feeBuy/setDetail", {
                data: this.feeBuy,
                id: this.feeBuy.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "FeeBuyList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.feeBuy.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
